import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Form, AsyncInputAutocomplete } from '@engloba-tech/englobity';
import { NAME_SPACE } from 'i18n';
import { experiences } from 'services';
import { useFormRelatedExperiencesStyles } from './formRelatedExperiences.styles';

export function FormRelatedExperiences({ formRef, onSubmit }) {
  const [inputs, setInputs] = useState([]);
  const { t } = useTranslation(NAME_SPACE.MULTILANGUAGE_EXPERIENCES);
  const classes = useFormRelatedExperiencesStyles();

  function handleSubmit() {
    onSubmit([...inputs]);
  }

  function handleExperienceAutocomplete(elements) {
    setInputs([...elements]);
  }

  return (
    <>
      <Form
        className={classes.formExperiences}
        elementRef={formRef}
        onKeyPress={e => {
          if (e.which === 13) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        onSubmit={handleSubmit}
        autoComplete="off"
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AsyncInputAutocomplete
              onChange={(e, element) => handleExperienceAutocomplete(element)}
              label={t('relatedExperiences.properties.name')}
              required
              multiple
              variant="outlined"
              icon={<SearchIcon />}
              value={inputs || []}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={option => `${option.name} - ${option.language}`}
              requestAction={queryFilter => experiences.getUsingQueryFilter(queryFilter, false)}
              validators={!inputs?.length ? ['required'] : []}
              errorMessages={[t('validations.required')]}
            />
          </Grid>
        </Grid>
      </Form>
    </>
  );
}

FormRelatedExperiences.propTypes = {
  formRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  onSubmit: PropTypes.func.isRequired
};
